var map = {
	"./8426454_3918927.svg": 8462,
	"./GV.png": 4512,
	"./UW.png": 3027,
	"./VIT.png": 4358,
	"./amazon_aws.png": 213,
	"./azure.png": 6494,
	"./fareportal.png": 5621,
	"./github.png": 8870,
	"./hackerrank.png": 31,
	"./isro.png": 8634,
	"./mad-logo.png": 7293,
	"./mad.png": 7341,
	"./mlh-logo.png": 5268,
	"./mozilla.png": 7767,
	"./msds.png": 3848,
	"./narayana.png": 8234,
	"./nasscom.png": 8927,
	"./nmit.png": 8307,
	"./osc.png": 3754,
	"./plugxr.png": 9541,
	"./toi-nie.png": 5120,
	"./tutorialspoint.png": 3034,
	"./udemy.png": 2281,
	"./vijay.jpeg": 4171,
	"./wsoc-icon.png": 8021,
	"./wsoc.png": 1319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;